import script from "./Commodityspecification.vue?vue&type=script&setup=true&lang=js"
export * from "./Commodityspecification.vue?vue&type=script&setup=true&lang=js"

import "./Commodityspecification.vue?vue&type=style&index=0&id=436ab5b7&lang=scss"
import "./Commodityspecification.vue?vue&type=style&index=1&id=436ab5b7&lang=scss&scoped=scoped"

import exportComponent from "C:\\Users\\23586\\Desktop\\美国站\\h5\\us-station-number\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-436ab5b7"]])

export default __exports__